// Taken from https://abhishekdutta.org/blog/standalone_uuid_generator_in_javascript.html
export const uuidBrowser = () => {
    const tempURL = URL.createObjectURL(new Blob());
    const uuid = tempURL.toString();
    URL.revokeObjectURL(tempURL);
    // Remove prefix (e.g. blob:null/, blob:www.test.com/, ...)
    return uuid.substr(uuid.lastIndexOf('/') + 1);
};
//# sourceMappingURL=uuid-browser.js.map